import React, {useState} from 'react';
import styles from './css-modules/overlay.module.css';
import Fade from 'react-reveal/Fade';
import AudioLink from './Audio';

function OverlaySlideshow(props){
  const [transBolean, setTransBolean] = useState(false);

  setTimeout(function(){ setTransBolean(true)}, 750);

    return (
      <div className={styles.overlayContent} style={{height: window.innerHeight}}>
        <div className={styles.pattern}></div>
        <div className={styles.OverlaySlideshow}>
          <div className={styles.OverlaySlideshow_content}>
            <div className={styles.overLaySlideshow_imageContainer}>{props.render()}</div>
          </div>
          <div className={styles.OverlayDescription_Desc}>{props.description}</div>
          {props.withAudio && <div className={styles.overlay_audio}>
            <Fade when={transBolean} duration={500}>
              <AudioLink link={props.audioLink}/>
            </Fade>
          </div>}
          <div className={styles.overlaySlideshow_source}>
            {props.source.length !== 0 && <p>Source: {props.source}</p>}
            {props.originalLink && <span onClick={() => window.open(props.originalLink)} className={styles.overlaySlideshow_link}>Original Link</span>}
          </div>
          <div className={styles.overlaySlideshow_bg}></div>
        </div>
      </div>
    )
}

export default OverlaySlideshow;
